import { FormTemplate } from '@src/core';

const ExclusionForm: FormTemplate = {
  step: {
    questions: {
      nameInitials: {
        sequence: 1,
        type: 'text',
        label: 'Iniciais do  Nome',
        placeholder: 'Ex: Maria Conceição da Silva, informe MCS',
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
        decoration: true,
      },
      excludedAt: {
        sequence: 2,
        type: 'date',
        fieldType: 'date',
        label: 'Data',
        validator: {
          dataType: 'string',
          required: true,
        },
        decoration: true,
      },
      hospitalName: {
        sequence: 3,
        type: 'radio',
        label: 'Hospital',
        options: ['AMPARO MATERNAL', 'SÃO PAULO'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },
      reason: {
        sequence: 4,
        type: 'radio',
        label: 'Motivo da exclusão?',
        validator: {
          dataType: 'string',
          required: true,
        },
        options: [
          'Barreira linguística', // 'É estrangeira',
          'Menor de 18 anos',
          'Não possui acesso a Internet',
          'Parto instrumental',
          'Perda gestacional',
          'Puérpera se recusou a assinar TCLE',
        ],
        fullWidth: true,
        requestDetail: {
          label: 'Detalhe o motivo escolhido',
          conditions: [{ condition: 'Há critérios não atendidos' }],
        },
      },
    },
  },
};

export { ExclusionForm };
